import React, { useState, useEffect } from 'react';
import './CadastrarSecretaria.css';
import { message } from 'antd';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const initialState = {
  prefeitura: '',
  nome: '',
  sigla: '',
};

export default function CadastrarSecretaria() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [prefeituras, setPrefeituras] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  useEffect(() => {
    carregarPrefeituras();
  }, []);

  const carregarPrefeituras = async () => {
    try {
      setLoading(true);
      const response = await api.get(API_CONFIG.ENDPOINTS.PREFEITURA.CONSULTAR_PREFEITURA);
      
      if (response.data.status) {
        const prefeiturasData = response.data.prefeituras || [];
        setPrefeituras(prefeiturasData.map(pref => ({
          id: pref.PRE_ID,
          nome: pref.PRE_NOME
        })));
      } else {
        message.error('Erro ao carregar prefeituras');
      }
    } catch (error) {
     // console.error('Erro ao carregar prefeituras:', error);
      message.error('Erro ao carregar prefeituras');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === 'sigla') {
      formattedValue = value.toUpperCase();
    }

    setForm({ ...form, [name]: formattedValue });
    setTouched({ ...touched, [name]: true });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.prefeitura) newErrors.prefeitura = 'Campo obrigatório';
    if (!form.nome) newErrors.nome = 'Campo obrigatório';
    if (!form.sigla) newErrors.sigla = 'Campo obrigatório';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const dadosParaEnviar = {
          ORG_SIGLA: form.sigla,
          ORG_DESCRICAO: form.nome,
          ORG_PRE_ID: parseInt(form.prefeitura)
        };

        //console.log('Dados sendo enviados:', dadosParaEnviar);

        const response = await api.post(API_CONFIG.ENDPOINTS.ORGAO.CADASTRAR_ORGAO, dadosParaEnviar);

        if (response.data.status) {
          message.success('Secretaria cadastrada com sucesso!');
          setForm(initialState);
          setTouched({});
          setSubmitted(false);
        } else {
          message.error(response.data.message || 'Erro ao cadastrar secretaria');
        }
      } catch (error) {
       // console.error('Erro ao cadastrar secretaria:', error);
        if (error.response?.data) {
         // console.error('Detalhes do erro:', error.response.data);
          message.error(error.response.data.message || 'Erro ao cadastrar secretaria');
        } else {
          message.error('Erro ao cadastrar secretaria');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const showError = (field) => (submitted || touched[field]) && errors[field];

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Cadastrar Secretaria</h1>
        <div className="modal-content">
          <form className="form-secretaria" onSubmit={handleSubmit} autoComplete="off">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Vincular Prefeitura <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="prefeitura"
                  value={form.prefeitura}
                  onChange={handleChange}
                  className={showError('prefeitura') ? 'erro' : ''}
                  disabled={loading}
                >
                  <option value="">Selecione a Prefeitura</option>
                  {prefeituras.map(prefeitura => (
                    <option key={prefeitura.id} value={prefeitura.id}>
                      {prefeitura.nome}
                    </option>
                  ))}
                </select>
                {showError('prefeitura') && <span className="msg-erro">{errors.prefeitura}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Nome <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="nome"
                  placeholder="Nome da Secretaria"
                  value={form.nome}
                  onChange={handleChange}
                  className={showError('nome') ? 'erro' : ''}
                  disabled={loading}
                />
                {showError('nome') && <span className="msg-erro">{errors.nome}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Sigla <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="sigla"
                  placeholder="Ex: SMOSP"
                  value={form.sigla}
                  onChange={handleChange}
                  className={showError('sigla') ? 'erro' : ''}
                  maxLength="10"
                  disabled={loading}
                />
                {showError('sigla') && <span className="msg-erro">{errors.sigla}</span>}
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                className="cadastro-submit-button"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 